const envType = process.env.REACT_APP_ENV; // Environment type from environment variables
const isProd = envType === 'PROD';

const stripeTestKey =
  'pk_test_51NWd4GE7dm1zrLgMuh9UCQNLX9aN81iYuAw8moaLSuv2WXVRcSQgnd6DoggHttTN7PnvbY6HvDLw805axDfiekgF00SPatI5Qe';
const stripeKey =
  'pk_live_51NWd4GE7dm1zrLgMqCcjyryuW8RuXFp1O5VbYIqJxYIpn9CF2Qm2PPPeix7Rsz9nUmsHRDcnLBC23hUZHE7ML7UZ00OoePHfF3';

export const publicKey = isProd ? stripeKey : stripeTestKey;
